<ng-container *ngIf="(asService.state$ | async).hasHeader && (asService.breakpoints$ | async).isMobile; else elseBlock">
    <eui-toolbar-logo *ngIf="(asService.state$ | async).hasHeaderLogo"></eui-toolbar-logo>

    <eui-toolbar-environment *ngIf="(asService.state$ | async).hasHeaderEnvironment">
        {{ (asService.state$ | async).environmentValue }}
    </eui-toolbar-environment>

    <eui-toolbar-app *ngIf="(asService.state$ | async).appName" appName="{{ (asService.state$ | async).appName }}"></eui-toolbar-app>

    <ng-container *ngTemplateOutlet="toolbarItems"></ng-container>
</ng-container>

<ng-template #elseBlock>
    <ng-content select="eui-toolbar-logo"></ng-content>
    <ng-content select="eui-toolbar-app"></ng-content>
    <ng-content select="eui-toolbar-environment"></ng-content>
    <ng-container *ngTemplateOutlet="toolbarItems"></ng-container>
</ng-template>


<ng-template #toolbarItems>
    <ng-content select="eui-toolbar-items"></ng-content>
</ng-template>
